import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Alert, Button, Form, Schema } from 'rsuite';
import { fetchSinToken } from '../../helpers/fetch';
import { TextField } from '../../helpers/FormControlRSuit';

export const NuevaContrasenia = ({match: { params }}) => {
    let history = useHistory();
    const [formValue, setFormValue] = useState({
        password: '',
        password2: ''
    });
    const [form, setform] = useState({});
    const [disabledBtn, setDisabledBtn] = useState(false);

    const handleSubmit = async () => {
        setDisabledBtn(true);
        if (form.check()) {
            const resp = await fetchSinToken(`passwordrecovery/${params.id}`, formValue, 'POST', 'json');
            const body = await resp.json();
            if(!body.ok) {
                Alert.error(body.message, 5000)
                setDisabledBtn(false)
            }else {
                Alert.success(body.data.msg);
                setTimeout(() => {
                    history.push("/login");
                }, 2000);
            }
        }
    }


    return (
        <Form
            fluid
            ref={ref => (setform(ref))}
            onChange={formValue => {
                setFormValue(formValue);
            }}
            formValue={formValue}
            model={model}
        >
            <div className="text-center m-auto">
                <h5 className="auth-title mb-4">Recuperar contraseña</h5>
                <p className="text-muted mb-4 mt-3">
                    Sigue los siguientes pasos para reestablecer tu contraseña.
                </p>
            </div>
            <div className="row mt-2">
                <div className="col-md-6">
                    <TextField 
                        label="Contraseña"
                        name="password"
                        type="password"
                        placeholder="Contraseña"
                    />
                </div>
                <div className="col-md-6">
                    <TextField 
                        label="Repetir contraseña"
                        name="password2"
                        type="password"
                        placeholder="Contraseña"
                    />
                </div>
                <small className="ml-2" style={{fontSize: '0.7rem'}}><span className="d-none1d-sm-inline">Crea tu contraseña para entrar a tu perfil </span>(minimo 8 caracteres).</small>
            </div>
            <div className="row">
                <div className="col text-center">
                    <Button 
                        onClick={handleSubmit} 
                        appearance="primary" 
                        loading={disabledBtn}
                    >
                        Restablecer Contraseña
                    </Button>
                </div>
            </div>
        </Form>
    )
}

const { StringType } = Schema.Types;

let model = Schema.Model({
    password: StringType()
        .isRequired('La contraseña es requerida')
        .minLength(8, 'Minimo 8 caracteres'),
    password2: StringType()
        .isRequired('La contraseña es requerida')
        .addRule((value, data) => {
            if (value !== data.password) {
            return false;
            }
            return true;
        }, 'La contraseña no coincide'),
});